<template>
  <v-main style="min-height: 60vh">
    <v-container class="responsive-template-content">
      <v-row dense style="margin-top: 5em; margin-bottom: 5em">
        <v-col cols="12" md="6">
          <v-col class="col-md-12 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="24" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-domain</v-icon
                >
                Ma page employeur
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Créez et gérer une page publique pour présenter votre
                entreprise.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/company/manage/my-page"
                >
                  Gérer ma page employeur
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" md="6">
          <v-col class="col-md-12 col-sm-12 col-xs-12">
            <v-card color="white" dark elevation="24" shaped>
              <v-card-title class="text-h5" style="color: #6b6868">
                <v-icon style="padding-right: 0.3em; color: #6b6868"
                  >mdi-account-details-outline</v-icon
                >
                Informations personnelles
              </v-card-title>

              <v-card-text
                class="font-weight-light text-h6"
                style="color: #6b6868"
              >
                Gérer vos informations personnelles et paramètres du compte
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  to="/company/personal-informations"
                >
                  Editer mes informations personnelles
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Footer from "@/components/common/Footer.vue";
import Vue from "vue";

export default Vue.extend({
  name: "CompanyMyAccount",
  data: function () {
    return {
      items: [
        {
          action: "local_activity",
          title: "Attractions",
          items: [{ title: "List Item" }],
        },
        {
          action: "restaurant",
          title: "Dining",
          active: true,
          items: [
            { title: "Breakfast & brunch" },
            { title: "New American" },
            { title: "Sushi" },
          ],
        },
      ],
    };
  },
});
</script>

<style scoped></style>
